import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Menu extends Component {
	constructor(props) {
		super(props);

		this.mobileBreakpoint = window.matchMedia(`(max-width: 991px)`).matches;
		this.showTopicInfo = this.showTopicInfo.bind(this);
		this.showInfo = this.showInfo.bind(this);
		this.setTopic = this.setTopic.bind(this);
		this.renderMenuItem = this.renderMenuItem.bind(this);
		this.renderTopicItem = this.renderTopicItem.bind(this);

		this.elementRef = React.createRef();
		const {topics} = this.props;
		this.state = {
			currentTopicId: !this.mobileBreakpoint ? topics[0]?.id : null,
			currentSubMenuHeight: null,
			currentMenuId: null,
		};
	}

	componentDidMount() {
		const subMenuElements = this.elementRef.current.querySelectorAll('.B10-topic-selector__submenu');

		Array.from(subMenuElements).forEach((subMenuElement) => {
			const subMenuStyle = window.getComputedStyle(subMenuElement);

			subMenuElement.dataset.maxHeight = subMenuStyle.getPropertyValue('height');
			subMenuElement.style.height = '0px';
		});
	}

	// Amended to switch out background images on ALL links
	setTopic(evt) {
		const { currentTopicId } = this.state;
		const { topics, showInfo, showBackgroundOnly } = this.props;
		const currentSubMenuHeight = evt.currentTarget.parentElement.querySelector('.B10-topic-selector__submenu').dataset.maxHeight;
		let newTopicId = evt.currentTarget.dataset.id;
		const topicInfo = topics.find((topic) => { return topic.id === newTopicId; }).info;

		if (newTopicId === currentTopicId) return;

		this.setState({
			currentTopicId: newTopicId,
			currentSubMenuHeight,
		});
	}

	openLink = (evt) => {
		window.location.href = evt.currentTarget.dataset.link;
	}

	showTopicInfo(evt) {
		const { currentTopicId } = this.state;
		const { topics, showInfo } = this.props;
		let newTopicId = evt.currentTarget.dataset.id;
		const topicInfo = topics.find((topic) => { return topic.id === newTopicId; }).info;
		topicInfo.link = evt.currentTarget.dataset.link;

		if (newTopicId !== currentTopicId) {
			showInfo(topicInfo);
		}

		this.setState({
			currentTopicId: newTopicId,
		});
	}

	showInfo(evt) {
		evt.preventDefault();

		const { currentTopicId } = this.state;
		const { topics, showInfo } = this.props;

		const menuId = evt.currentTarget.dataset.id;
		const currentTopic = topics.find((topic) => { return topic.id === currentTopicId; }).menu;
		const currentMenu = currentTopic.find((info) => { return info.id === menuId; });

		currentMenu.info.link = currentMenu.link;
		showInfo(currentMenu.info);

		this.setState({
			currentMenuId: menuId,
		});
	}

	renderMenuItem(subMenuItem) {
		const { currentMenuId } = this.state;
		const { viewport } = this.props;
		let menuItemClass = 'B10-topic-selector__submenu-item';
		let clickFunction = null;

		if (currentMenuId === subMenuItem.id) {
			menuItemClass += ' is-active';
		}

		if (['lg', 'xl', 'xxl'].includes(viewport)) {
			clickFunction = this.showInfo;
		}


		return (
			<li key={subMenuItem.id} className={menuItemClass}>
				<a href={subMenuItem.link} data-id={subMenuItem.id} onClick={clickFunction}>{subMenuItem.title}</a>
			</li>
		);
	}

	renderTopicItem(menuItem) {
		const { currentTopicId, currentSubMenuHeight } = this.state;
		const { viewport } = this.props;
		let topicItemClass = 'B10-topic-selector__menu-item';
		let subMenuStyle = null;
		let clickFunction = this.setTopic;

		if (!menuItem.menu) {
			clickFunction = this.showTopicInfo;
		}

		if (['xs', 'sm', 'md'].includes(viewport) && !menuItem.menu) {
			clickFunction = this.openLink;
		}

		if (currentTopicId) {
			subMenuStyle = { height: '0px' };
		}

		if (menuItem.id === currentTopicId) {
			topicItemClass += ' is-open';
			subMenuStyle = { height: currentSubMenuHeight };
		}

		return (
			<li key={menuItem.id} className={topicItemClass}>
				<span className="B10-topic-selector__menu-item__link" role="presentation" data-id={menuItem.id} data-link={menuItem.link} onClick={clickFunction}>
					{menuItem.title}
					{menuItem.menu ? <span className="B10-topic-selector__indicator" /> : null}
				</span>
				{menuItem.menu ? <ul className="B10-topic-selector__submenu" style={subMenuStyle}>{menuItem.menu.map(this.renderMenuItem)}</ul> : null}
			</li>
		);
	}

	render() {
		const { topics } = this.props;

		return (
			<ul className="B10-topic-selector__menu" ref={this.elementRef}>
				{topics.map(this.renderTopicItem)}
			</ul>
		);
	}
}

Menu.defaultProps = {
	viewport: 'lg',
};

Menu.propTypes = {
	viewport: PropTypes.string,
	topics: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			menu: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					title: PropTypes.string.isRequired,
					link: PropTypes.string.isRequired,
					info: PropTypes.shape({
						title: PropTypes.string,
						description: PropTypes.string,
						background: PropTypes.string,
					}),
				}).isRequired,
			),
		}).isRequired,
	).isRequired,
	showInfo: PropTypes.func.isRequired,
	showBackgroundOnly: PropTypes.func.isRequired,
};

export default Menu;
